// React libraries
import React from "react";
// Custom Styles
import { useStyles } from "./HomePageStyles";
// React Swiper
import Swiper from 'react-id-swiper';
// CSS
// import './Swiper.css';
// Icon
import OntegoOneLogoBlack from "../../../icons/OntegoOne/OntegoOneLogoBlack";
import Grid from '@mui/material/Grid';
import { FunctionButton } from "../../index";
import { PageWrapper } from "../../index";
export const HomePage = (props) => {
    const classes = useStyles(props);
    const { previewWidth, previewHeight, data } = props;
    const params = {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
    };
    return (React.createElement(PageWrapper, { previewHeight: previewHeight, previewWidth: previewWidth },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { className: classes.logoContainer, item: true, md: 12, style: { height: previewHeight * 12.5 / 100 } },
                React.createElement(OntegoOneLogoBlack, { className: classes.logo })),
            React.createElement(Grid, { item: true, md: 12, style: { height: previewHeight * 87.5 / 100 } },
                React.createElement(Swiper, Object.assign({}, params), Object.values(data).map((func) => (React.createElement("div", { style: { height: previewHeight * 86 / 100 } },
                    React.createElement(Grid, { className: classes.functionButtonContainer, container: true, spacing: 2 }, func.map((data) => (React.createElement(Grid, { item: true, md: 6 },
                        React.createElement(FunctionButton, { onClick: () => { }, previewHeight: previewHeight, previewWidth: previewWidth, data: data })))))))))))));
};
export default React.memo(HomePage);
